export enum VerificationTaskType {
  DocumentReview = 0,
  BackgroundCheck = 1,
  CertificationVerification = 2,
  IdentityVerification = 3,
  BankAccountVerification = 4,
  FacilityInspection = 5,
  PasswordResetVerification = 6
}
